module.exports = __webpack_public_path__ + "img/silverware-fork-knife.46cdb8d4.svg";